module.exports = __webpack_public_path__ + "static/media/screenshot-competition-main-page.f0f16a63.png";